import * as Uniform from '../Uniform';

import VERT_DEFAULT from './Vertex/default.vert';
import FRAG_DEFAULT from './Fragment/default.frag';

export default class Shader {
	[key: string]: any;

	public positionAttr:string = "a_position";
	public texcoordAttr:string = "a_texcoord";

	public u_outputCoords:Uniform.Uniform1i = new Uniform.Uniform1i(1.0);
	
	private inputTexture:string = "u_input";
	protected textures:string[] = [];

	public getTextures = ():string[] => ["u_input", ...this.textures];
	
	public vert = ():string => VERT_DEFAULT;
	public frag = ():string => FRAG_DEFAULT;
}